import { render, staticRenderFns } from "./GroupInvitation.vue?vue&type=template&id=f226c466&scoped=true&"
import script from "./GroupInvitation.vue?vue&type=script&lang=js&"
export * from "./GroupInvitation.vue?vue&type=script&lang=js&"
import style0 from "./GroupInvitation.vue?vue&type=style&index=0&id=f226c466&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f226c466",
  null
  
)

export default component.exports